import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

interface StatCardProps {
  title: string;
  value: React.ReactNode;
  subtitle?: React.ReactNode;
}

/** Compact KPI card: uppercase label, big value, optional subtitle. */
const StatCard: React.FC<StatCardProps> = ({ title, value, subtitle }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
      <Typography variant="subtitle2" color="text.secondary"
        sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', fontSize: 11.5 }}>
        {title}
      </Typography>
      <Typography variant="h5" component="div" sx={{ fontWeight: 800, mt: 0.5 }}>
        {value}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subtitle}</Typography>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
